/* set-conditions.js — the „Bedingungen" panel next to the Starter Set price (snippets/set-conditions.liquid).
   One delegated listener, loaded with defer by every button (the guard makes repeat tags harmless).
   Click toggles the panel named by aria-controls; Escape closes the open panel and returns focus to its button;
   a click outside closes an open „up" panel (sticky bars). No-JS: the panel stays hidden (the terms are also in
   the FAQ and the AGB). */
(function () {
  if (window.__hpBed) return;
  window.__hpBed = true;

  function panelOf(btn) {
    var id = btn.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }
  function visibleBottom() {
    var limit = window.innerHeight;
    Array.prototype.forEach.call(document.querySelectorAll('#product-sticky-bar, .product-sticky-bar, .launch-sticky'), function (bar) {
      var r = bar.getBoundingClientRect();
      if (r.height > 0 && r.top < limit && r.bottom >= window.innerHeight - 1) limit = r.top;
    });
    return limit;
  }
  function reveal(p) {
    if (p.classList.contains('hp-bed-panel--up')) return;
    var r = p.getBoundingClientRect();
    var over = r.bottom - (visibleBottom() - 12);
    if (over > 0) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollBy({ top: Math.min(over, Math.max(0, r.top - 72)), behavior: reduce ? 'auto' : 'smooth' });
    }
  }
  function setOpen(btn, open) {
    var p = panelOf(btn);
    if (!p) return;
    p.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) reveal(p);
  }
  function openButtons() {
    return document.querySelectorAll('.hp-bed[aria-expanded="true"]');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.hp-bed') : null;
    if (btn) {
      e.preventDefault();
      setOpen(btn, btn.getAttribute('aria-expanded') !== 'true');
      return;
    }
    Array.prototype.forEach.call(openButtons(), function (b) {
      var p = panelOf(b);
      if (p && p.classList.contains('hp-bed-panel--up') && !p.contains(e.target)) setOpen(b, false);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var list = openButtons();
    if (!list.length) return;
    Array.prototype.forEach.call(list, function (b) { setOpen(b, false); });
    var last = list[list.length - 1];
    var active = document.activeElement;
    var inside = false;
    Array.prototype.forEach.call(list, function (b) {
      var p = panelOf(b);
      if (b === active || (p && p.contains(active))) { inside = true; last = b; }
    });
    if (inside || active === document.body) last.focus();
  });
})();
